/**
 * 初始化不会执行 只在更新才会执行的useEffect
 */
import {useEffect, useRef} from 'react'

export const useUpdateEffect = (effect, deps) => {
  const isMounted = useRef(false);

  useEffect(() => {
    return () => { isMounted.current = false; }
  }, []);

  useEffect(() => {
    if(!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
  }, deps);

}
